import React from "react";
import { dishes } from "../data/dishes";
import { useTheme, useDocumentTitle } from "../hooks/useSite";

export default function LegalPage({ type }) {
  useTheme(dishes[0]);
  const privacy = type === "privacy";
  useDocumentTitle(privacy ? "Privacy" : "Terms");
  return (
    <section className="ro-legal">
      <div className="ro-container ro-container--narrow">
        <h1>
          {privacy ? "Privacy" : "Website"} <span className="ro-outline">{privacy ? "information" : "terms"}</span>
        </h1>
        {privacy ? (
          <>
            <h2>What this site does with data.</h2>
            <p>
              This website uses Google Analytics page-view tracking. The event booking and feedback forms send the details you enter to the RollOver team by email through EmailJS. Delivery, map and social links open third-party services that apply their own policies.
            </p>
            <h2>Newsletter.</h2>
            <p>Email addresses entered in the footer newsletter form are used only to send RollOver news and offers.</p>
          </>
        ) : (
          <>
            <h2>Using this website.</h2>
            <p>Online orders are placed on Swiggy or Zomato, not on this website.</p>
            <h2>Bookings.</h2>
            <p>The event booking form sends a request to the team. A booking is confirmed only when the team contacts you.</p>
          </>
        )}
      </div>
    </section>
  );
}
